/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to search for tags
 * @export
 * @interface SearchTagsNotesCommand
 */
export interface SearchTagsNotesCommand {
    /**
     * Text to search for in tag labels
     * @type {string}
     * @memberof SearchTagsNotesCommand
     */
    searchText?: string;
}

/**
 * Check if a given object implements the SearchTagsNotesCommand interface.
 */
export function instanceOfSearchTagsNotesCommand(value: object): value is SearchTagsNotesCommand {
    return true;
}

export function SearchTagsNotesCommandFromJSON(json: any): SearchTagsNotesCommand {
    return SearchTagsNotesCommandFromJSONTyped(json, false);
}

export function SearchTagsNotesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchTagsNotesCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'searchText': json['searchText'] == null ? undefined : json['searchText'],
    };
}

export function SearchTagsNotesCommandToJSON(json: any): SearchTagsNotesCommand {
    return SearchTagsNotesCommandToJSONTyped(json, false);
}

export function SearchTagsNotesCommandToJSONTyped(value?: SearchTagsNotesCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchText': value['searchText'],
    };
}

